import type { ReactNode } from 'react';
import type { Role } from '@shared/user';
import { cx } from '@client/shared/lib/cx.ts';
import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'accent' | 'ok' | 'warn' | 'danger';

const toneClass: Record<BadgeTone, string | undefined> = {
  neutral: styles.neutral,
  accent: styles.accent,
  ok: styles.ok,
  warn: styles.warn,
  danger: styles.danger,
};

export interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  className?: string;
  children?: ReactNode;
}

export function Badge({ tone = 'neutral', dot = false, className, children }: BadgeProps) {
  return (
    <span className={cx(styles.badge, toneClass[tone], className)}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}

export const ROLE_BADGE_TONE: Record<Role, BadgeTone> = {
  owner: 'accent',
  admin: 'warn',
  agent: 'neutral',
  billing: 'ok',
};
